import {
  NormalizedStorageObject,
  StorageObject,
} from "../../../../services/api/instances/storageApi/types/object_types";
import type { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";

export function denormalizeStorageObjects<T extends StorageObjectValue>(
  ids: string[],
  entities: Record<string, NormalizedStorageObject<T>>,
): StorageObject<T>[] {
  const mapToStorageObject = (id: string): StorageObject<T> => {
    const entity = entities[id];
    const { childrenIds, ...rest } = entity;

    const hasChildren = childrenIds.length > 0 && entity.value === null;

    return {
      ...rest,
      children: hasChildren ? childrenIds.map(mapToStorageObject) : undefined,
    };
  };

  const rootIds = ids.filter((id) => {
    const entity = entities[id];
    return entity?.parentId === null;
  });

  return rootIds.map(mapToStorageObject);
}
